import template from './template.html'

var rutas = {
  'INGR3': 'contabilidad.polizas.deudoresDiversos',
  'CMF': 'contabilidad.polizas.provisionNomina',
  'CMFL': 'contabilidad.polizas.provisionNominaLNF',
  'INGR2': 'contabilidad.polizas.facturacion',
  'INGR': 'contabilidad.polizas.pagosNominaMXN',
  'INGR4': 'contabilidad.polizas.deudoresDiversosEgresos',
  'INGR5': 'contabilidad.polizas.pagosNominaUSD',
  'BANC': 'contabilidad.polizas.provisionIngresosPagos',
  'NODED': 'contabilidad.polizas.nodeducibles',
  'PPG': 'contabilidad.polizas.provisiongastos',
  'PPGP': 'contabilidad.polizas.provisiongastospagos',
  'PPNP': 'contabilidad.polizas.provisionNominaconpagos',
  'PPNPS': 'contabilidad.polizas.provisionNominaconpagosSucursales',
  'FCC': 'contabilidad.polizas.facturascanceladas',
}

function ContabilidadPolizasComponent ($filter, $state, $catalogos) {
  var $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.ir = ir

  $ctrl.tiposPolizas = {}
  $ctrl.promise = null
  $ctrl.orderBy = $filter('orderBy')
  $ctrl.groupBy = $filter('groupBy')

  function $onInit () {
    $ctrl.promise = $catalogos.get('tipoPolizas')
      .then(function (data) {
        $ctrl.tiposPolizas = $ctrl.orderBy(data, ['agrupacion', 'descripcion'])
          .map(function (item) {
            item.url = $state.href(rutas[item.referencia])
            return item
          })
        $ctrl.tiposPolizas = $ctrl.groupBy($ctrl.tiposPolizas, 'agrupacion')
      })
  }

  function ir (item) {
    if (rutas[item]) {
      $state.go(rutas[item])
    }
  }
}

angular.module('contabilidad.polizas')
  .component('contabilidadPolizas', {
    controller: ContabilidadPolizasComponent,
    template,
  })



// WEBPACK FOOTER //
// ./src/contabilidad/polizas/components/component.js